import OrderAction from './order-action.vue';
export default OrderAction;
